import React from "react";

export const ProjectSettingsUnsavedContext = React.createContext(null);

export function useProjectSettingsDirty(areaKey, dirty) {
  const context = React.useContext(ProjectSettingsUnsavedContext);

  React.useEffect(() => {
    if (!context?.registerDirty || !areaKey) return undefined;
    context.registerDirty(areaKey, Boolean(dirty));
    return () => context.registerDirty(areaKey, false);
  }, [areaKey, context, dirty]);
}
